import { render, staticRenderFns } from "./AdminApprovalSetPrint.vue?vue&type=template&id=133cbe85&scoped=true&"
import script from "./AdminApprovalSetPrint.vue?vue&type=script&lang=js&"
export * from "./AdminApprovalSetPrint.vue?vue&type=script&lang=js&"
import style0 from "./AdminApprovalSetPrint.vue?vue&type=style&index=0&id=133cbe85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133cbe85",
  null
  
)

export default component.exports